<template>
  <noneP></noneP>
</template>
<script>
export default {
  components: {
    noneP: () =>
      import(/* webpackChunkName: "components" */ "@/components/none.vue")
  },
  data() {
    return {};
  }
};
</script>